import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import SubHeader from '@quikr/ui/src/common/SubHeader';
import { subHeaderLinks } from '../../../gql/vap';

const SubHeaderWrapper = ({ city: { id, name } }) => {
  const { loading, data, error } = useQuery(subHeaderLinks, {
    variables: {
      payload: {
        id,
        name
      }
    },
    errorPolicy: 'all'
  });
  if (loading) return null;
  if (error || !data || !data.qhsublinks) return null;
  return <SubHeader subHeaderLinks={data.qhsublinks} />;
};

SubHeaderWrapper.propTypes = {
  data: PropTypes.object,
  city: PropTypes.object
};

export default SubHeaderWrapper;
